export default __webpack_public_path__ + "static/media/storesampler1.11261655.png";